/**
 * Query keys for category-related API calls
 */

export const categoryQueryKeys = {
  all: ["categories"] as const,
  tree: () => ["categories", "tree"] as const,
  mainWithCounts: () => ["categories", "mainWithCounts"] as const,
} as const;